export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type Query = {
  __typename?: 'Query';
  getMineWallHistory: Maybe<Array<Maybe<UserWallEvent>>>;
};

export type QueryGetMineWallHistoryArgs = {
  date: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type UserWallEvent = {
  __typename?: 'UserWallEvent';
  author: Maybe<Scalars['ID']['output']>;
  details: Maybe<Scalars['String']['output']>;
  event: Maybe<UserWallEventType>;
  fullDetails: Maybe<Scalars['String']['output']>;
  time: Maybe<Scalars['Int']['output']>;
  userEventId: Maybe<Scalars['ID']['output']>;
};

export enum UserWallEventType {
  LookBookCreated = 'LookBookCreated',
  LookBookOrderPlaced = 'LookBookOrderPlaced',
  LookBookVisitedByClient = 'LookBookVisitedByClient',
  OrderPlaced = 'OrderPlaced',
  PrivateSessionCreated = 'PrivateSessionCreated',
  PrivateSessionDeactivated = 'PrivateSessionDeactivated',
  PrivateSessionVisitedByClient = 'PrivateSessionVisitedByClient',
  PublicSessionCreated = 'PublicSessionCreated',
  PublicSessionDeactivated = 'PublicSessionDeactivated',
  SessionsStats = 'SessionsStats',
  ZalamoUpdate = 'ZalamoUpdate',
  ZalamoWelcomeMessage = 'ZalamoWelcomeMessage',
}
